import { render, staticRenderFns } from "./newProject.vue?vue&type=template&id=19a050bc&scoped=true"
import script from "./newProject.vue?vue&type=script&lang=js"
export * from "./newProject.vue?vue&type=script&lang=js"
import style0 from "./newProject.vue?vue&type=style&index=0&id=19a050bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a050bc",
  null
  
)

export default component.exports